import { render, staticRenderFns } from "./addDishtype.vue?vue&type=template&id=7aa72c78&scoped=true"
import script from "./addDishtype.vue?vue&type=script&lang=ts"
export * from "./addDishtype.vue?vue&type=script&lang=ts"
import style0 from "./addDishtype.vue?vue&type=style&index=0&id=7aa72c78&prod&lang=scss&scoped=true"
import style1 from "./addDishtype.vue?vue&type=style&index=1&id=7aa72c78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_babel-co_fdc8552a8ede636d403bf9928f1c7af2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aa72c78",
  null
  
)

export default component.exports